import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http'
import { Mitter } from 'mitter-web-core';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
//import { type } from 'os';

import {BehaviorSubject, Observable, Subject, Subscriber,pipe} from 'rxjs';
import { CommonService } from './common.service';
import { AuthService } from '../authentication/auth.service';
@Injectable()
export class MitterService {
  mitter: any;
  firebase: any;
  fcmUnsubscribers: any[];
  firebase2: any;
vflag = 0;
  petcartUserId: any;
  petcartUserRole: any;
  private mitterConfig = {
      mitterCentralUrl: "https://api.mitter.io",
      mitterApplicationId: "c42a25aa-738b-4c56-8e17-68f6502c93b8"
      //mitterApplicationId: "7e55f444-71a4-446b-96ca-438ab0e4d1c6"  //central "c42a25aa-738b-4c56-8e17-68f6502c93b8"
      //mitterApplicationId: "42477aae-fef8-44e5-aa9d-b06fcd53aef2" gk
  }

  private interserviceUrls = {
      base: "https://petcart.in:8085",
      userEntry: "/v1/user-entries/",
      liveChannel: "/v1/live-channels/"
  }

  constructor(private http: Http, public commonService: CommonService, public authService: AuthService) {
    this.fcmUnsubscribers = [];
     if (!firebase.apps.length) {
      this.firebase = firebase.initializeApp({
        messagingSenderId: "768291296939",
        apiKey: "AAAAsuG61qs:APA91bETLbiieHmYCFZJfdvyVkuLmtgQVTJg_9i2bMoXWElnanKmg_oXhyYbfmfyKEzYt5buuBRE_qUJPc1FWEKPePRL6zZ1vfdXACp71QHWd10MmiJY04QR1p4nZYyvikmzRNtwnTA1",
        projectId: "petcart-chat"
      });
      }else{
        this.firebase = firebase.apps[0];
      }
     
      
 this.petcartUserId = this.commonService.getuserId();
 console.log("Fetched petcartUserId in constructor: ", this.petcartUserId);

   const ur = this.authService.getRoleId();
    if (ur === 3) {
     this.petcartUserRole = 'DOCTOR';
    }else {
     this.petcartUserRole = 'PATIENT';
   }
  }

  getUserRole() {
    return this.petcartUserRole;
  }
  getMitter() {
    return this.mitter;
  }
 
  getAllLiveChannels() {
    return new Promise((resolve, reject) => {
      this.http.get(
        this.interserviceUrls.base + this.interserviceUrls.liveChannel
            + "?externalUserId=" + this.petcartUserId
      ).pipe(map(response => response.json())).subscribe(data => {
        resolve(data)
      })
    })
  }

  getUnreadMessagesCount(channelId: String) {
    if (!this.mitter) return 0;

    return this.mitter.getMessagesForChannel(channelId)
      .filter(message => message.senderId.identifier !== this.mitter.getUserId()) // Messages sent by others
      .map(message =>
        message.timelineEvents // for each timelineEvent
          .map(e => e.type === 'mitter.mtet.ReadTime' &&  // it is a ReadTimeEvent
            e.subject.identifier === this.mitter.getUserId() // and current user has read it
          )
          .some(readByUser => readByUser === true) // true if user has read this message
      )
      .filter(readByUser => readByUser === false) // get only unread message entries
      .length;
  }

  getSentTime(message) {
    if (!message || !message.timelineEvents) return null;
    let sentTimeEvent = message.timelineEvents.find(e => e.type === 'mitter.mtet.SentTime');
    return sentTimeEvent && sentTimeEvent.eventTimeMs;
  }

  doesJoinChannelEventExist(channel) {
    console.log("ChannelEvents:", channel.timelineEvents)
    return channel.timelineEvents
      .find(timelineEvent =>
        timelineEvent.type === 'com.petcart.channel.JoinChannel' &&
        timelineEvent.subject.identifier === this.mitter.getUserId()
      ) && true;
  }

  synchChannelTtl(channelId: String) {
    return new Promise((resolve, reject) => {
      this.http.get(
        this.interserviceUrls.base + this.interserviceUrls.liveChannel + channelId
      ).pipe(map(response => response.json())).subscribe(data => {
        resolve(data.ttl);
      })
    })
  }

  logout() {
    console.log("mitterservice logout");
    console.log("deleting mitter web core object")
    this.mitter = null;
    console.log("removing callbacks with function: ", this.fcmUnsubscribers);

    this.fcmUnsubscribers.forEach(unsubscriber => unsubscriber());
  }

  synchUser(refreshAuth: Boolean = false) {
    this.petcartUserId = this.commonService.getuserId();
    console.log(this.petcartUserId);
    return new Promise((resolve, reject) => {
      this.http.get(
        this.interserviceUrls.base + this.interserviceUrls.userEntry +
          this.petcartUserId + "?refreshUserAuthorization=" + refreshAuth
      ).pipe(map(response => response.json())).subscribe( data => {
          this.mitter = new Mitter(
            this.mitterConfig.mitterApplicationId, data.mitterUserId,
            data.mitterUserAuthorization, "v1", this.mitterConfig.mitterCentralUrl);
          this.mitter.configureFCM(this.firebase);
          this.mitter.setTokenRefreshCallback(this.synchToken.bind(this));
          resolve(true);
      })
    });
  }

  synchToken() {
    return new Promise((resolve, reject) => {
      this.http.get(
        this.interserviceUrls.base + this.interserviceUrls.userEntry +
          this.petcartUserId + "?refreshUserAuthorization=true"
      ).pipe(map(response => response.json())).subscribe( data => {
        console.log("mitter-web-core just requested a new token ffs");
        resolve(data.mitterUserAuthorization);
      })
    })
    // .then(() => {
    //   setTimeout(() => {
    //     this.getAllLiveChannels()
    //     .then((data: any[]) => {
    //       data.forEach(liveChannel => {
    //         this.mitter.getAllMessagesForChannel(liveChannel.mitterChannelId)
    //       })
    //     })
    //   }, 5000);
    // })
  }

  initiateVideoChat(channeld: String) {
    const url = this.interserviceUrls.base + this.interserviceUrls.liveChannel +
      channeld + "/participant/" + this.petcartUserId + "/video";

    return new Promise((resolve, reject) => {
      this.http.post(url, {})
        .pipe(map(response => response.json()))
        .subscribe(data => resolve(data));
    });
  }

  //TODO Remove; this actually happens from the server side
  
}
